import type { RootState } from 'state';

function isAuthenticated(state: RootState): boolean {
  const { authenticated } = state.auth;

  return authenticated;
}

export default isAuthenticated;
